export default "__VITE_ASSET__DodQhUR5__"